export class LineItemModifierDTO {
    constructor(
        public id: string,
        public productId: string,
        public skuId: string,
        public name: string,
        public amount: number,
        public quantity: number,
        public dateCreated: string,
        public dateUpdated: string
    ) { }
}

export class LineItemDTO {
    constructor(
        public id: string,
        public productId: string,
        public skuId: string,
        public name: string,
        public amount: number,
        public quantity: number,
        public modifiers: LineItemModifierDTO[],
        public externalReference: string | null,
        public dateCreated: string,
        public dateUpdated: string,
        public customerRefundableUntil: string | null = null,
        public paidOnline: boolean = true,
    ) { }
}
